import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-add-to-cart',
  templateUrl: './icon-add-to-cart.component.html',
  styleUrls: ['./icon-add-to-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconAddToCartComponent {}
